export const GENDER_OPTIONS = [{
        label: "全て",
        value: undefined
    }, {
        label: "男性",
        value: "male"
    }, {
        label: "女性",
        value: "female"
    }];
export const OPTION_SEX_STATUS = [{
        value: 0,
        label: ''
    }, {
        value: 1,
        label: '男性'
    }, {
        value: 2,
        label: '女性'
    }];
export const LABEL_MAP_SEX_STATUS = OPTION_SEX_STATUS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});
